import { writable } from "svelte/store"

const valuta_per_dominio = writable(null)

valuta_per_dominio.su_cambio = valuta_per_dominio.subscribe

export { valuta_per_dominio }
